(() => {
  "use strict";

  const BUILD = "v501-consolidation-safe-commerce-authority";
  const CANONICAL_BEATS = "/pages/beats";

  if (window.OTTRecordThemeV501 && window.OTTRecordThemeV501.build === BUILD) return;

  const canonicalizeBeatLinks = (root = document) => {
    root.querySelectorAll('a[href*="/pages/beatstore"]').forEach((link) => {
      const raw = link.getAttribute("href") || "";
      try {
        const url = new URL(raw, window.location.origin);
        if (url.pathname !== "/pages/beatstore" && url.pathname !== "/pages/beatstore/") return;
        url.pathname = CANONICAL_BEATS;
        if (url.origin === window.location.origin) {
          link.setAttribute("href", `${url.pathname}${url.search}${url.hash}`);
        } else {
          link.setAttribute("href", url.toString());
        }
      } catch (_) {
        if (raw === "/pages/beatstore" || raw === "/pages/beatstore/") {
          link.setAttribute("href", CANONICAL_BEATS);
        }
      }
    });
  };

  const signalCartChanged = (source = "theme-v501") => {
    try {
      window.dispatchEvent(
        new CustomEvent("ottrecord:cart-changed", {
          detail: { source },
        })
      );
    } catch (_) {}
  };

  const bindNativeCartEvents = () => {
    ["cart:refresh", "cart:updated", "product:added", "ajaxProduct:added"].forEach((eventName) => {
      document.addEventListener(eventName, () => signalCartChanged(eventName));
    });

    try {
      if (
        typeof subscribe === "function" &&
        typeof PUB_SUB_EVENTS === "object" &&
        PUB_SUB_EVENTS &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => signalCartChanged("shopify-pubsub-cart-update"));
      }
    } catch (_) {}
  };

  const init = () => {
    canonicalizeBeatLinks();
    bindNativeCartEvents();

    document.addEventListener("shopify:section:load", (event) => {
      canonicalizeBeatLinks(event && event.target ? event.target : document);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  window.OTTRecordThemeV501 = Object.freeze({
    build: BUILD,
    canonicalBeats: CANONICAL_BEATS,
    canonicalizeBeatLinks,
    signalCartChanged,
  });
})();
